/**
 * scam-engine.js — разбор сообщения и ссылки на признаки мошенничества.
 *
 * Pure analysis, zero DOM, ZERO NETWORK. Грузится /scam-check и
 * tests/js/scam-engine.test.mjs.
 *
 * ═══════════════════════════════════════════════════════════════════════════
 * ЧТО ЭТОТ ИНСТРУМЕНТ ДЕЛАЕТ И ЧЕГО НЕ ДЕЛАЕТ
 * ═══════════════════════════════════════════════════════════════════════════
 * Он разбирает ТЕКСТ и СТРУКТУРУ ССЫЛКИ. Он НЕ проверяет репутацию домена по
 * базам и не знает, зарегистрирован ли домен вчера. Сервис проверки ссылок,
 * отвечающий «домен не в чёрных списках», выдаёт СВЕЖИЙ фишинг за безопасный:
 * в списки он попадает через часы или дни, а деньги переводят за минуты.
 *
 * ── v2 (2026-09-13): почему переписан ────────────────────────────────────
 * Прогон v1 на обычных текстах дал девять «Это мошенничество» на законном:
 *   · СМС банка «Не сообщайте никому этот код: 4821» — сработала «секретность»;
 *   · «Установите приложение для отслеживания заказа» — «удалённый доступ»;
 *   · «Переведите деньги Маше за обед» — «безопасный счёт»;
 *   · login.microsoftonline.com, storage.googleapis.com, s3.amazonaws.com,
 *     sbermarket.ru, alfa-romeo.ru, pineapple.com — бренд искался ПОДСТРОКОЙ.
 * И шесть пропусков: голый домен без http (так в СМС пишут почти всегда),
 * «Мама, я попала в аварию» (`\w` не видит кириллицу), любой обман на
 * немецком, испанском и ещё шести языках сайта — шаблоны были только ru/en.
 * Инструмент, который зовёт мошенником собственный банк человека, перестают
 * слушать, и на настоящей атаке он уже не спасает. Отсюда:
 *   1. шаблоны на ВСЕХ десяти языках сайта;
 *   2. бренд сравнивается ПО ТОКЕНАМ метки (целиком, с «фишинговой»
 *      приставкой вроде -online/-secure или с опечаткой в одну букву), плюс
 *      список родственных официальных доменов;
 *   3. «защитные» фразы настоящих уведомлений («не сообщайте код никому»)
 *      гасят совпадения, которые целиком внутри них;
 *   4. вердикт ступенчатый: у признаков три яруса — «абсолютный» (законного
 *      объяснения не бывает: назвать код, безопасный счёт, AnyDesk, адрес
 *      перед @), «решающий» (сам по себе «очень похоже», вместе с чем угодно
 *      ещё — мошенничество) и обычные веса.
 *
 * ── Главный признак, который прячет браузер ─────────────────────────────
 * Домен из кириллических букв, неотличимых от латинских: `sbеrbank.ru`, где
 * «е» — русская. Единственный надёжный признак — СМЕШЕНИЕ ПИСЬМЕННОСТЕЙ
 * ВНУТРИ ОДНОЙ МЕТКИ домена. Punycode (xn--) раскодируется, и проверка идёт по
 * настоящим буквам.
 *
 * ── Вторая вещь, которую не показывают ──────────────────────────────────
 * Всё, что стоит ДО символа @ в ссылке, — имя пользователя, а не адрес.
 *
 * ⚠️⚠️ В шаблонах для кириллицы, корейского и арабского НЕЛЬЗЯ писать `\w` и
 * `\b`: в JavaScript оба ASCII-шные даже с флагом u. `заблокир\w+` не совпадает
 * со словом «заблокирован». Только явные классы [а-яё] и границы вида
 * (?:^|[^а-яё]).
 */
(function (root, factory) {
    var api = factory();
    if (typeof module === 'object' && module.exports) { module.exports = api; }
    if (root) { root.ScamEngine = api; }
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
'use strict';

/* ═══════════════════════════════════════════════════════════════════════
   ПИСЬМЕННОСТИ
   ═══════════════════════════════════════════════════════════════════════ */

var SCRIPT_RANGES = [
    { id: 'latin',  re: /[A-Za-z]/ },
    { id: 'cyrillic', re: /[Ѐ-ӿ]/ },
    { id: 'greek',  re: /[Ͱ-Ͽ]/ },
    { id: 'arabic', re: /[؀-ۿ]/ },
    { id: 'han',    re: /[一-鿿]/ },
    { id: 'hangul', re: /[가-힯]/ }
];

function scriptsIn(s) {
    var out = [];
    SCRIPT_RANGES.forEach(function (r) { if (r.re.test(s)) out.push(r.id); });
    return out;
}

/* Буквы, которые в кириллице/греческом выглядят как латинские. Не полный
   Unicode confusables — тот его срез, что реально используют в подделках. */
var CONFUSABLE = {
    'а': 'a', 'е': 'e', 'о': 'o', 'р': 'p', 'с': 'c', 'у': 'y', 'х': 'x',
    'А': 'A', 'В': 'B', 'Е': 'E', 'К': 'K', 'М': 'M', 'Н': 'H', 'О': 'O',
    'Р': 'P', 'С': 'C', 'Т': 'T', 'У': 'Y', 'Х': 'X', 'і': 'i', 'ѕ': 's',
    'ј': 'j', 'ԛ': 'q', 'ԝ': 'w', 'ɡ': 'g', 'α': 'a', 'ο': 'o', 'ρ': 'p',
    'ν': 'v', 'κ': 'k', 'ι': 'i', 'υ': 'u', 'ԁ': 'd', 'һ': 'h', 'ӏ': 'l'
};
/* Цифры вместо букв — только для сравнения с брендом («g0suslugi»). */
var DIGIT_LOOK = { '0': 'o', '1': 'l', '3': 'e', '4': 'a', '5': 's', '8': 'b' };

function skeleton(label) {
    return label.split('').map(function (ch) { return CONFUSABLE[ch] || ch; }).join('').toLowerCase();
}
function digitSkeleton(s) {
    return s.replace(/[0134589]/g, function (d) { return DIGIT_LOOK[d] || d; });
}

/* ═══════════════════════════════════════════════════════════════════════
   PUNYCODE (RFC 3492) — только декодирование
   ═══════════════════════════════════════════════════════════════════════ */
function punyDecode(input) {
    var base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, n = 128, i = 0, bias = 72;
    var output = [];
    var basic = input.lastIndexOf('-');
    if (basic < 0) basic = 0;
    for (var j = 0; j < basic; j++) {
        if (input.charCodeAt(j) >= 0x80) return null;
        output.push(input.charCodeAt(j));
    }
    function digit(cp) {
        if (cp - 48 < 10) return cp - 22;
        if (cp - 65 < 26) return cp - 65;
        if (cp - 97 < 26) return cp - 97;
        return base;
    }
    function adapt(delta, numPoints, first) {
        var k = 0;
        delta = first ? Math.floor(delta / damp) : delta >> 1;
        delta += Math.floor(delta / numPoints);
        for (; delta > ((base - tMin) * tMax) >> 1; k += base) delta = Math.floor(delta / (base - tMin));
        return Math.floor(k + (base - tMin + 1) * delta / (delta + skew));
    }
    for (var idx = basic > 0 ? basic + 1 : 0; idx < input.length;) {
        var oldi = i, w = 1;
        for (var k = base; ; k += base) {
            if (idx >= input.length) return null;
            var d = digit(input.charCodeAt(idx++));
            if (d >= base) return null;
            i += d * w;
            var t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
            if (d < t) break;
            w *= base - t;
            if (w > 1e9) return null;
        }
        var outLen = output.length + 1;
        bias = adapt(i - oldi, outLen, oldi === 0);
        n += Math.floor(i / outLen);
        i %= outLen;
        if (n > 0x10FFFF) return null;
        output.splice(i++, 0, n);
    }
    try { return String.fromCodePoint.apply(null, output); } catch (e) { return null; }
}
function decodeLabel(label) {
    if (!/^xn--/i.test(label)) return label;
    var d = punyDecode(label.slice(4).toLowerCase());
    return d == null ? label : d;
}

/* ═══════════════════════════════════════════════════════════════════════
   БРЕНДЫ
   ═══════════════════════════════════════════════════════════════════════
   names — токены, по которым бренд узнаётся в ЧУЖОМ домене. Короткие и
   многозначные имена (alfa, ing, dana, bri) сюда намеренно не входят:
   alfa-romeo.ru — не Альфа-Банк. hosts — официальные и родственные домены
   (включая поддомены), которые признак НЕ дают.
*/
var BRANDS = [
    { id: 'sber',      names: ['sberbank', 'sber', 'sberbankonline'], hosts: ['sberbank.ru', 'sber.ru', 'sberbank.com', 'sbermarket.ru', 'sberdevices.ru', 'sberhealth.ru', 'sberbank-ast.ru', 'sbrf.ru'] },
    { id: 'tbank',     names: ['tinkoff', 'tbank'], hosts: ['tinkoff.ru', 'tbank.ru', 'tinkoffinsurance.ru', 'tinkoffjournal.ru'] },
    { id: 'vtb',       names: ['vtb'], hosts: ['vtb.ru', 'vtb.com', 'vtb24.ru'] },
    { id: 'alfabank',  names: ['alfabank', 'alfaonline'], hosts: ['alfabank.ru', 'alfabank.com'] },
    { id: 'gosuslugi', names: ['gosuslugi', 'gosuslugy', 'gosuslug'], hosts: ['gosuslugi.ru'] },
    { id: 'nalog',     names: ['nalog'], hosts: ['nalog.gov.ru', 'nalog.ru'] },
    { id: 'pochta',    names: ['pochta', 'pochtarossii'], hosts: ['pochta.ru'] },
    { id: 'wildberries', names: ['wildberries', 'wildberies'], hosts: ['wildberries.ru', 'wb.ru', 'wildberries.by', 'wildberries.kz'] },
    { id: 'ozon',      names: ['ozon'], hosts: ['ozon.ru', 'ozon.com', 'ozonbank.ru'] },
    { id: 'avito',     names: ['avito'], hosts: ['avito.ru', 'avito.st'] },
    { id: 'mts',       names: ['mts'], hosts: ['mts.ru', 'mtsbank.ru', 'mts.by'] },
    { id: 'beeline',   names: ['beeline'], hosts: ['beeline.ru', 'beeline.kz', 'beeline.uz'] },
    { id: 'megafon',   names: ['megafon'], hosts: ['megafon.ru', 'megafon.tj'] },
    { id: 'tele2',     names: ['tele2'], hosts: ['tele2.ru', 't2.ru'] },
    { id: 'kyivstar',  names: ['kyivstar'], hosts: ['kyivstar.ua'] },
    { id: 'yandex',    names: ['yandex'], hosts: ['yandex.ru', 'ya.ru', 'yandex.com', 'yandex.net', 'yandex.kz', 'yandex.by'] },
    { id: 'vk',        names: ['vkontakte'], hosts: ['vk.com', 'vk.ru', 'vkontakte.ru'] },
    { id: 'monobank',  names: ['monobank'], hosts: ['monobank.ua'] },
    { id: 'privatbank', names: ['privatbank', 'privat24'], hosts: ['privatbank.ua', 'privat24.ua'] },
    { id: 'novaposhta', names: ['novaposhta', 'novapost'], hosts: ['novaposhta.ua', 'novapost.com'] },
    { id: 'diia',      names: ['diia'], hosts: ['diia.gov.ua'] },
    { id: 'kaspi',     names: ['kaspi'], hosts: ['kaspi.kz'] },
    { id: 'apple',     names: ['apple', 'icloud', 'appleid'], hosts: ['apple.com', 'icloud.com', 'me.com', 'apple.news'] },
    { id: 'google',    names: ['google', 'gmail'], hosts: ['google.com', 'gmail.com', 'googleapis.com', 'googleusercontent.com', 'google.ru', 'youtube.com', 'goo.gl', 'forms.gle', 'withgoogle.com', 'gstatic.com', 'google.de', 'google.fr', 'google.es', 'google.co.id', 'google.com.br', 'google.co.kr'] },
    { id: 'microsoft', names: ['microsoft', 'outlook', 'office365', 'hotmail'], hosts: ['microsoft.com', 'outlook.com', 'live.com', 'office.com', 'microsoftonline.com', 'office365.com', 'hotmail.com', 'sharepoint.com', 'azure.com', 'windows.net'] },
    { id: 'paypal',    names: ['paypal'], hosts: ['paypal.com', 'paypal.me'] },
    { id: 'amazon',    names: ['amazon'], hosts: ['amazon.com', 'amazonaws.com', 'amazon.de', 'amazon.fr', 'amazon.es', 'amazon.co.uk', 'amazon.com.br', 'amazon.in', 'amazon.sa', 'amazon.ae'] },
    { id: 'netflix',   names: ['netflix'], hosts: ['netflix.com'] },
    { id: 'binance',   names: ['binance'], hosts: ['binance.com'] },
    { id: 'telegram',  names: ['telegram'], hosts: ['telegram.org', 't.me', 'telegram.me'] },
    { id: 'whatsapp',  names: ['whatsapp'], hosts: ['whatsapp.com', 'wa.me', 'whatsapp.net'] },
    { id: 'instagram', names: ['instagram'], hosts: ['instagram.com'] },
    { id: 'facebook',  names: ['facebook'], hosts: ['facebook.com', 'fb.com', 'fb.me', 'meta.com'] },
    { id: 'steam',     names: ['steamcommunity', 'steampowered'], hosts: ['steamcommunity.com', 'steampowered.com'] },
    { id: 'dhl',       names: ['dhl'], hosts: ['dhl.com', 'dhl.de'] },
    { id: 'fedex',     names: ['fedex'], hosts: ['fedex.com'] },
    { id: 'ups',       names: ['ups'], hosts: ['ups.com'] },
    { id: 'usps',      names: ['usps'], hosts: ['usps.com'] },
    { id: 'royalmail', names: ['royalmail'], hosts: ['royalmail.com'] },
    { id: 'laposte',   names: ['laposte', 'colissimo'], hosts: ['laposte.fr', 'laposte.net', 'colissimo.fr'] },
    { id: 'correos',   names: ['correos'], hosts: ['correos.es', 'correos.com'] },
    { id: 'ctt',       names: ['cttexpresso'], hosts: ['ctt.pt'] },
    { id: 'sparkasse', names: ['sparkasse'], hosts: ['sparkasse.de'] },
    { id: 'santander', names: ['santander'], hosts: ['santander.com', 'santander.es', 'santander.com.br', 'santander.de', 'santander.co.uk'] },
    { id: 'bbva',      names: ['bbva'], hosts: ['bbva.es', 'bbva.com', 'bbva.mx'] },
    { id: 'nubank',    names: ['nubank'], hosts: ['nubank.com.br', 'nu.com.mx'] },
    { id: 'itau',      names: ['itau'], hosts: ['itau.com.br'] },
    { id: 'bradesco',  names: ['bradesco'], hosts: ['bradesco.com.br'] },
    { id: 'mercadolibre', names: ['mercadolibre', 'mercadopago', 'mercadolivre'], hosts: ['mercadolibre.com', 'mercadopago.com', 'mercadolivre.com.br', 'mercadolibre.com.mx'] },
    { id: 'klikbca',   names: ['klikbca', 'bcamobile'], hosts: ['bca.co.id', 'klikbca.com'] },
    { id: 'mandiri',   names: ['bankmandiri', 'livinmandiri'], hosts: ['bankmandiri.co.id'] },
    { id: 'tokopedia', names: ['tokopedia'], hosts: ['tokopedia.com'] },
    { id: 'shopee',    names: ['shopee'], hosts: ['shopee.co.id', 'shopee.com', 'shopee.com.br', 'shopee.sg'] },
    { id: 'kakao',     names: ['kakao', 'kakaobank'], hosts: ['kakao.com', 'kakaobank.com', 'kakaocorp.com'] },
    { id: 'naver',     names: ['naver'], hosts: ['naver.com'] },
    { id: 'coupang',   names: ['coupang'], hosts: ['coupang.com'] },
    { id: 'alrajhi',   names: ['alrajhi', 'alrajhibank'], hosts: ['alrajhibank.com.sa'] },
    { id: 'absher',    names: ['absher'], hosts: ['absher.sa'] },
    { id: 'aramex',    names: ['aramex'], hosts: ['aramex.com'] }
];

/* Слова, которыми мошенники обвешивают имя бренда: «sberbank-online»,
   «paypalsecure», «secure-apple». Со словом не из списка («sbermarket»,
   «applebees», «amazonaws») бренд НЕ считается подделанным. */
var PHISH_AFFIX = ['online', 'onlain', 'onlayn', 'secure', 'security', 'login', 'signin', 'sign', 'support',
    'help', 'helpdesk', 'verify', 'verification', 'confirm', 'bank', 'pay', 'payment', 'payments', 'id',
    'account', 'accounts', 'acc', 'service', 'services', 'bonus', 'bonuses', 'gift', 'gifts', 'promo',
    'app', 'apps', 'auth', 'card', 'cards', 'lk', 'cabinet', 'kabinet', 'my', 'web', 'client', 'clients',
    'official', 'info', 'update', 'safe', 'protect', 'protection', 'money', 'cash', 'prize', 'win',
    'mobile', 'mob', 'delivery', 'dostavka', 'track', 'tracking', 'parcel', 'post', 'gov', 'gos', 'go',
    'refund', 'return', 'vozvrat', 'kompensaciya', 'compensation', 'wallet', 'lottery', 'check', 'alert',
    'notice', 'ru', 'com', 'net', 'org', 'rf', 'online24', 'store', 'shop', 'sale', 'center', 'centre',
    'group', 'team', 'reward', 'rewards', 'recovery', 'unlock', 'reset', 'invest', 'crypto'];

var SHORTENERS = ['bit.ly', 'tinyurl.com', 'goo.gl', 't.co', 'is.gd', 'clck.ru', 'vk.cc', 'cutt.ly', 'rb.gy',
    'shorturl.at', 'surl.li', 'u.to', 'ow.ly', 'buff.ly', 'rebrand.ly', 's.id', 't.ly', 'tiny.cc', 'v.gd',
    'qps.ru', 'bit.do', 'ya.cc', 'shorturl.asia', 'bitly.ws', 'lnk.bio', 'did.li'];

var FREE_HOSTING = ['weebly.com', 'wixsite.com', 'netlify.app', 'vercel.app', 'pages.dev', 'github.io',
    'firebaseapp.com', 'web.app', 'glitch.me', 'blogspot.com', '000webhostapp.com', 'tilda.ws',
    'ucoz.ru', 'narod.ru', 'herokuapp.com', 'ngrok.io', 'ngrok-free.app', 'r2.dev', 'workers.dev',
    'wordpress.com', 'square.site', 'webflow.io', 'framer.app', 'carrd.co', 'yolasite.com', 'godaddysites.com'];

/* Слабый признак: регистрация дешёвая и быстрая, одноразовых сайтов много. */
var RISKY_TLDS = ['zip', 'mov', 'top', 'xyz', 'click', 'link', 'work', 'rest', 'cfd', 'sbs', 'icu', 'buzz',
    'quest', 'tk', 'ml', 'ga', 'cf', 'gq', 'pw', 'cam', 'bond', 'lol', 'mom', 'monster', 'cyou', 'autos',
    'boats', 'hair', 'beauty', 'skin', 'makeup', 'loan', 'bid', 'win', 'shop', 'online', 'site', 'live', 'vip'];

/* Зоны для распознавания ГОЛЫХ доменов в тексте («sberbank-online.top/login»).
   Список конечный намеренно: без него «т.е.», «file.txt» и «end.So» стали бы
   ссылками. */
var KNOWN_TLDS = ('com net org info biz ru su рф рус укр ua by kz uz kg tj am az ge md ee lv lt pl de fr es pt it ' +
    'nl be ch at se no fi dk cz sk hu ro bg gr tr il ir sa ae qa kw om bh eg ma tn dz jo lb iq sy ' +
    'in pk bd lk id my sg th vn ph kr jp cn hk tw au nz ca us uk mx br ar cl co pe ve ec uy ' +
    'io me co tv cc ws to ly gl gd fm am eu asia ' + RISKY_TLDS.join(' ') +
    ' app dev page cloud tech store space website fun pro club site today news world one ' +
    'blog email agency digital network support services center group company solutions ' +
    'finance bank money cash credit loans exchange trade market deals sale gift gifts').split(/\s+/);
var TLD_SET = {};
KNOWN_TLDS.forEach(function (t) { TLD_SET[t] = 1; });

/* Двухуровневые публичные суффиксы: у «bank.co.uk» настоящий домен —
   bank.co.uk, а не co.uk. */
var MULTI_SUFFIX = ['co.uk', 'org.uk', 'ac.uk', 'gov.uk', 'com.br', 'gov.br', 'com.ua', 'gov.ua', 'kiev.ua',
    'in.ua', 'pp.ua', 'org.ua', 'co.id', 'go.id', 'or.id', 'ac.id', 'web.id', 'co.kr', 'or.kr', 'go.kr',
    'com.sa', 'gov.sa', 'com.eg', 'gov.eg', 'com.tr', 'gov.tr', 'com.au', 'co.jp', 'gov.ru', 'msk.ru',
    'spb.ru', 'com.ru', 'org.ru', 'net.ru', 'com.mx', 'gob.mx', 'com.ar', 'gob.es', 'gouv.fr', 'com.cn',
    'co.in', 'com.pk', 'com.kz', 'gov.kz', 'com.by', 'gov.by', 'ae.org', 'com.pt', 'gov.pt'];

var EXECUTABLE_EXT = ['apk', 'exe', 'scr', 'msi', 'jar', 'bat', 'cmd', 'vbs', 'ps1', 'xapk', 'apks', 'dmg', 'pkg'];

/* ═══════════════════════════════════════════════════════════════════════
   РАЗБОР ССЫЛКИ
   ═══════════════════════════════════════════════════════════════════════ */

var TRAIL = /[.,;:!?)\]}»"'’”…]+$/;

/**
 * Ссылки в тексте: со схемой, с www., голые домены из известных зон и
 * «имя@домен/путь» без схемы. Адрес почты (имя@домен без пути) ссылкой
 * не считается.
 */
function findUrls(text) {
    return findUrlsDetailed(text).map(function (x) { return x.url; });
}
function findUrlsDetailed(text) {
    var s = String(text || '');
    var out = [];
    var seen = {};
    var spans = [];
    function add(raw, idx) {
        raw = raw.replace(TRAIL, '');
        if (!raw) return;
        var explicit = /^https?:\/\//i.test(raw);
        var norm = explicit ? raw : 'http://' + raw;
        var key = norm.toLowerCase();
        if (seen[key]) return;
        seen[key] = 1;
        out.push({ url: norm, bare: !explicit, shown: raw });
        spans.push([idx, idx + raw.length]);
    }
    function covered(i) { return spans.some(function (sp) { return i >= sp[0] && i < sp[1]; }); }

    var re1 = /(?:https?:\/\/|www\.)[^\s<>"'«»]+/gi, m;
    while ((m = re1.exec(s))) add(m[0], m.index);

    /* «sberbank.ru@evil.example/login» без схемы — приём с @ работает и так. */
    var re2 = /[^\s@<>"'«»\/]+@[^\s@<>"'«»\/]+\.[a-z\u0400-\u04ff]{2,24}(?::\d{2,5})?\/[^\s<>"'«»]*/giu;
    while ((m = re2.exec(s))) if (!covered(m.index)) add(m[0], m.index);

    var re3 = /((?:[\p{L}\p{N}](?:[\p{L}\p{N}-]{0,61}[\p{L}\p{N}])?\.)+([\p{L}]{2,24}|xn--[a-z0-9-]{2,59}))(?::\d{2,5})?(?:\/[^\s<>"'«»]*)?/gu;
    while ((m = re3.exec(s))) {
        var start = m.index;
        if (covered(start)) continue;
        var prev = s.charAt(start - 1);
        if (prev === '@' || prev === '.' || /[\p{L}\p{N}_-]/u.test(prev)) continue;
        var tld = m[2];
        if (!(TLD_SET[tld] || /^xn--/.test(tld))) continue;
        /* Зона в верхнем регистре посреди текста («end.So») — опечатка, не адрес. */
        if (tld !== tld.toLowerCase() && !/^www\./i.test(m[1])) continue;
        var labels = m[1].split('.');
        if (labels.length < 2 || labels[0].length < 2) continue;
        add(m[0], start);
    }
    return out;
}

function registrableOf(labels) {
    if (labels.length >= 3) {
        var last2 = labels.slice(-2).join('.');
        if (MULTI_SUFFIX.indexOf(last2) >= 0) return labels.slice(-3).join('.');
    }
    return labels.slice(-2).join('.');
}

function parseUrl(raw) {
    var out = { raw: raw, ok: false };
    var m = /^(https?):\/\/([^\/?#]*)([^?#]*)(\?[^#]*)?(#.*)?$/i.exec(raw);
    if (!m) return out;
    var authority = m[2];
    var at = authority.lastIndexOf('@');
    if (at >= 0) {
        out.userinfo = authority.slice(0, at);
        authority = authority.slice(at + 1);
    }
    var colon = authority.lastIndexOf(':');
    if (colon > authority.lastIndexOf(']')) {
        out.port = authority.slice(colon + 1);
        authority = authority.slice(0, colon);
    }
    out.host = authority.toLowerCase().replace(/\.$/, '');
    if (!out.host || !/^[\p{L}\p{N}.\-\[\]:]+$/u.test(out.host)) return out;
    out.ok = true;
    out.scheme = m[1].toLowerCase();
    out.path = m[3] || '';
    out.query = m[4] || '';
    out.labels = out.host.split('.');
    out.decodedLabels = out.labels.map(decodeLabel);
    out.decodedHost = out.decodedLabels.join('.');
    out.tld = out.labels.length > 1 ? out.labels[out.labels.length - 1] : '';
    out.registrable = registrableOf(out.labels);
    out.regCount = out.registrable.split('.').length;
    return out;
}

function tokensOf(label) {
    return label.split(/[-_]+/).filter(Boolean);
}
function digitTokens(label) {
    return label.replace(/(\d+)/g, '-$1-').split(/[-_]+/).filter(function (t) { return t && !/^\d+$/.test(t); });
}

/* Дамерау–Левенштейн с ранним выходом: нас интересует только «ровно одна
   правка» (sberbamk, gosuslugl, wildberies). */
function withinOneEdit(a, b) {
    if (a === b) return false;
    var la = a.length, lb = b.length;
    if (Math.abs(la - lb) > 1) return false;
    if (la === lb) {
        var diff = [];
        for (var i = 0; i < la; i++) if (a[i] !== b[i]) { diff.push(i); if (diff.length > 2) return false; }
        if (diff.length === 1) return true;
        return diff.length === 2 && diff[1] === diff[0] + 1 && a[diff[0]] === b[diff[1]] && a[diff[1]] === b[diff[0]];
    }
    var s = la < lb ? a : b, l = la < lb ? b : a, j = 0, k = 0, skipped = false;
    while (j < s.length && k < l.length) {
        if (s[j] === l[k]) { j++; k++; continue; }
        if (skipped) return false;
        skipped = true; k++;
    }
    return true;
}

function brandHit(token, name) {
    if (token === name) return 'exact';
    if (token.length > name.length) {
        if (token.indexOf(name) === 0 && PHISH_AFFIX.indexOf(token.slice(name.length)) >= 0) return 'affix';
        if (token.slice(-name.length) === name && PHISH_AFFIX.indexOf(token.slice(0, token.length - name.length)) >= 0) return 'affix';
    }
    if (name.length >= 6 && token.length >= 5 && withinOneEdit(token, name)) return 'typo';
    return null;
}

function hostIs(host, h) { return host === h || host.slice(-(h.length + 1)) === '.' + h; }

/**
 * Признаки ссылки. Возвращает { url, flags:[{id, weight, tier, data}] }.
 * tier: 'absolute' — законного объяснения нет; 'decisive' — сам по себе
 * «очень похоже», вместе с чем-то ещё — мошенничество; иначе вес 2/1.
 */
function analyzeUrl(raw, opts) {
    var u = parseUrl(raw);
    var flags = [];
    function add(id, weight, tier, data) { flags.push({ id: id, weight: weight, tier: tier || null, decisive: !!tier, data: data || {} }); }
    if (!u.ok) { add('unparsable', 1); return { url: u, flags: flags }; }

    var host = u.host;
    var isIp = /^\d{1,3}(\.\d{1,3}){3}$/.test(host) || /^\[[0-9a-f:]+\]$/i.test(host);
    var official = !isIp && BRANDS.some(function (b) { return b.hosts.some(function (h) { return hostIs(host, h); }); });

    /* 1. Смешение письменностей внутри одной метки — по НАСТОЯЩИМ буквам. */
    var mixed = false;
    u.decodedLabels.forEach(function (label, i) {
        var scripts = scriptsIn(label);
        if (scripts.length > 1) {
            mixed = true;
            add('mixed_script', 3, 'absolute', { label: label, scripts: scripts, encoded: u.labels[i] !== label ? u.labels[i] : null });
        }
    });

    /* 2. Punycode. Настоящие домены на кириллице (почта.рф) тоже так
          записываются — поэтому это слабый признак-пояснение, если внутри нет
          смешения; при смешении уже сработал абсолютный. */
    if (/(^|\.)xn--/.test(host) && !mixed) {
        add('punycode', 1, null, { host: host, decoded: u.decodedHost });
    }

    /* 3. Имя пользователя перед @. */
    if (u.userinfo) add('userinfo', 3, 'absolute', { shown: u.userinfo, real: host });

    /* 4. IP вместо имени. */
    if (isIp) add('ip_host', 2, null, { host: host });

    /* 5. Бренд в чужом домене: по токенам меток, со скелетом похожих букв и
          цифр. Официальные и родственные домены признака не дают. */
    if (!official && !isIp) {
        var regStart = u.labels.length - u.regCount;
        var hits = {};
        u.decodedLabels.forEach(function (label, idx) {
            if (idx >= u.labels.length - 1) return; // сама зона
            var sk = skeleton(label);
            var variants = [tokensOf(sk), digitTokens(sk), tokensOf(digitSkeleton(sk))];
            BRANDS.forEach(function (b) {
                if (hits[b.id]) return;
                b.names.forEach(function (n) {
                    if (hits[b.id]) return;
                    variants.forEach(function (toks) {
                        if (hits[b.id]) return;
                        toks.forEach(function (t) {
                            if (hits[b.id]) return;
                            var how = brandHit(t, n);
                            if (how) hits[b.id] = { brand: b.id, real: b.hosts[0], host: host, label: label, idx: idx, how: how, nonAscii: /[^\x00-\x7f]/.test(label) };
                        });
                    });
                });
            });
        });
        Object.keys(hits).forEach(function (k) {
            var h = hits[k];
            if (h.nonAscii && !mixed) {
                /* Метка целиком из похожих нелатинских букв, а читается как бренд. */
                add('homograph', 3, 'absolute', h);
            } else if (h.idx >= regStart) {
                add('brand_lookalike', 3, 'decisive', h);
            } else {
                add('brand_in_subdomain', 3, 'decisive', h);
            }
        });
        if (Object.keys(hits).length && /-/.test(u.registrable)) add('brand_hyphen', 2, null, { host: u.registrable });
    }

    /* 6. Файл программы по ссылке из сообщения. */
    var ext = (/\.([a-z0-9]{2,5})$/i.exec(u.path) || [])[1];
    if (ext && EXECUTABLE_EXT.indexOf(ext.toLowerCase()) >= 0) add('executable_link', 3, 'decisive', { ext: ext.toLowerCase() });

    if (!official) {
        if (SHORTENERS.indexOf(u.registrable) >= 0) add('shortener', 1, null, { host: u.registrable });
        var fh = FREE_HOSTING.filter(function (h) { return hostIs(host, h); })[0];
        if (fh) add('free_hosting', 1, null, { host: fh });
        if (RISKY_TLDS.indexOf(u.tld) >= 0) add('risky_tld', 1, null, { tld: u.tld });
        if (u.labels.length >= 5) add('deep_subdomains', 1, null, { n: u.labels.length });
        /* Только если схему написали явно: к голому домену «http://»
           дописали мы сами. */
        if (u.scheme === 'http' && !(opts && opts.bare)) add('no_https', 1);
        if (u.port && ['80', '443'].indexOf(u.port) < 0) add('odd_port', 1, null, { port: u.port });
    }
    return { url: u, flags: flags };
}

/* ═══════════════════════════════════════════════════════════════════════
   РАЗБОР ТЕКСТА — десять языков сайта
   ═══════════════════════════════════════════════════════════════════════
   Каждый сигнал — набор регулярок по языкам. Текст проверяется ВСЕМИ
   языками сразу: сообщение на английском приходит и русскоязычному
   человеку, а определять язык по трём словам ненадёжно.
*/
function R(src) { return new RegExp(src, 'iu'); }
var CY = '[а-яёіїєґ\']';

var TEXT_SIGNALS = [
    /* ── абсолютные ────────────────────────────────────────────────────── */
    { id: 'sms_code', weight: 3, tier: 'absolute', re: [
        // ru
        '(?:^|[^а-яё])(назов|продикту|скаж|сообщ|отправ|пришл|переш|скин|надикту)[а-яё]*\\s+(мне\\s+|нам\\s+)?(этот\\s+|полученн[а-яё]+\\s+|пришедш[а-яё]+\\s+|4-?х?\\s*значн[а-яё]+\\s+|цифры\\s+)?(код|цифры)',
        'код[а-яё]*\\s+из\\s+(смс|sms|сообщени|пуш)',
        'цифры\\s+из\\s+(смс|sms|сообщени)',
        'код,?\\s+который\\s+(вам\\s+|тебе\\s+)?(сейчас\\s+)?(прид[её]т|пришёл|пришел|поступит|поступил)',
        // uk
        '(?:^|[^а-яіїєґ])(назв|продикту|скаж|повідом|надішл|перешл)[а-яіїєґ]*\\s+(мені\\s+)?(цей\\s+|отриман[а-яіїєґ]+\\s+)?код',
        'код[а-яіїєґ]*\\s+з\\s+(смс|sms|повідомлен)',
        'цифри\\s+з\\s+(смс|sms|повідомлен)',
        // en
        '\\b(tell|give|read|send|share|forward|text)\\s+(me|us)\\s+(the|that|this|your)?\\s*(\\d-digit\\s+)?(verification\\s+|security\\s+|one[- ]time\\s+|otp\\s+|sms\\s+)?(code|otp|pin)\\b',
        '\\b(read|give|tell)\\s+(the|that|this)\\s+(\\d-digit\\s+)?(verification\\s+|security\\s+|one[- ]time\\s+)?code\\b',
        '\\bcode\\s+(we\\s+)?(just\\s+)?(sent|texted)\\s+(you|to\\s+your\\s+phone)',
        // de
        '(nennen|sagen|schicken|senden|geben|lesen)\\s+sie\\s+(mir\\s+|uns\\s+)?(bitte\\s+)?(den|diesen|ihren|die)\\s+(sms-?|bestätigungs-?|sicherheits-?)?(code|tan)\\b',
        '(nenn|sag|schick|gib|lies)\\s+(mir|uns)\\s+(bitte\\s+)?(den|diesen|deinen|die)\\s+(sms-?|bestätigungs-?)?(code|tan)\\b',
        '(sms-?code|tan-?nummer|bestätigungscode)[^.]{0,30}(nennen|mitteilen|durchgeben|vorlesen)',
        // es
        '(d[ií]ga(me|nos)|dime|env[ií]a(me|nos)|p[aá]sa(me|nos)|l[eé]a(me|nos)|facil[ií]te(me|nos))\\s+(el\\s+)?(c[oó]digo|pin)',
        'c[oó]digo\\s+que\\s+(le|te)\\s+(ha\\s+)?(lleg[oó]|llegar[aá]|enviamos|acabamos)',
        // fr
        '(donnez|dites|envoyez|communiquez|transmettez|lisez|donne|dis|envoie)[- ](moi|nous)\\s+(le|ce)\\s+code',
        'code\\s+(re[çc]u\\s+par\\s+sms|que\\s+vous\\s+(avez\\s+|allez\\s+)?re[çc]u)',
        // pt
        '(me\\s+)?(diga|passe|envie|informe|repasse|fala|manda|passa)[- ]?(me)?\\s+o\\s+c[oó]digo',
        'c[oó]digo\\s+que\\s+(chegou|voc[eê]\\s+recebeu|enviamos|vai\\s+chegar)',
        // id
        '(sebutkan|berikan|kirimkan|kirim|bacakan|bagikan|infokan)\\s+(kode|otp)',
        'kode\\s+(otp|verifikasi)\\s+(yang\\s+)?(masuk|dikirim|diterima|barusan)',
        // ko
        '인증\\s*번호[^.\\n]{0,15}(알려|불러|말씀|보내|전달)',
        '(문자|sms)(로|으로)?\\s*(받은|온|전송된)\\s*(인증)?\\s*(번호|코드)',
        // ar
        '(أرسل|ارسل|أعطني|اعطني|أخبرني|اخبرني|قل\\s+لي|زودني)[^.\\n]{0,20}(الرمز|الكود|رمز\\s+التحقق)',
        '(الرمز|الكود|رمز\\s+التحقق)\\s+(الذي|اللي)\\s+(وصلك|وصل|سيصلك|وصلتك)'
    ] },
    { id: 'safe_account', weight: 3, tier: 'absolute', re: [
        '(безопасн|резервн|защищённ|защищенн|специальн|страхов)[а-яё]*\\s+(банковск[а-яё]+\\s+)?(сч[её]т|ячейк)',
        'на\\s+сч[её]т\\s+(центробанка|цб|центрального\\s+банка|росфинмониторинга)',
        '(безпечн|резервн|захищен|спеціальн)[а-яіїєґ]*\\s+рахун',
        '\\b(safe|secure|protected|holding|safety)\\s+account\\b',
        '(sicheres|sicheren|geschütztes|geschützten)\\s+konto|treuhandkonto|sicherheitskonto',
        'cuenta\\s+(segura|protegida|de\\s+seguridad|refugio)',
        'compte\\s+(s[ée]curis[ée]|s[ûu]r|prot[ée]g[ée]|de\\s+s[ée]curit[ée]|refuge)',
        'conta\\s+(segura|protegida|de\\s+seguran[çc]a)',
        'rekening\\s+(aman|pengaman|penampungan|sementara\\s+yang\\s+aman)',
        '안전\\s*(계좌|보호\\s*계좌)',
        '(حساب\\s+آمن|حساب\\s+الأمان|حساب\\s+مؤمن|حساب\\s+حماية)'
    ] },
    { id: 'remote_access', weight: 3, tier: 'absolute', re: [
        'anydesk|any\\s+desk|teamviewer|team\\s+viewer|rustdesk|rust\\s+desk|airdroid|quicksupport|quick\\s+support|supremo|ammyy|ultraviewer|getscreen|аnydesk|эни\\s?деск|тимвьюер',
        'удал[её]нн[а-яё]+\\s+доступ', '(демонстраци|трансляци)[а-яё]+\\s+экрана',
        'віддален[а-яіїєґ]+\\s+доступ', 'демонстраці[а-яіїєґ]+\\s+екран',
        '\\bremote\\s+(access|control|desktop)\\b', '\\bshare\\s+your\\s+screen\\b',
        'fernzugriff|fernwartung|bildschirm\\s+(teilen|freigeben)',
        'acceso\\s+remoto|compart(ir|a)\\s+(la\\s+|su\\s+)?pantalla',
        'acc[eè]s\\s+[àa]\\s+distance|prise\\s+en\\s+main\\s+[àa]\\s+distance|partag(er|ez)\\s+(votre\\s+)?[ée]cran',
        'acesso\\s+remoto|compartilh(ar|e)\\s+(a\\s+|sua\\s+)?tela',
        'akses\\s+jarak\\s+jauh|bagikan\\s+layar|berbagi\\s+layar',
        '원격\\s*(제어|지원|접속)|화면\\s*공유',
        '(الوصول|التحكم)\\s+عن\\s+بعد|مشاركة\\s+الشاشة'
    ] },
    { id: 'gift_cards', weight: 3, tier: 'absolute', re: [
        '(куп|приобрет|оплат)[а-яё]*[^.\\n]{0,30}(подарочн[а-яё]+\\s+карт|карт[а-яё]*\\s+(steam|app\\s*store|google\\s*play|itunes))',
        'код[а-яё]*\\s+(с|от)\\s+(подарочн|карт[ы]?\\s+(steam|google|app))',
        '(купіть|придбайте)[^.\\n]{0,30}подарунков[а-яіїєґ]+\\s+карт',
        '\\b(buy|purchase|get)\\b[^.\\n]{0,30}\\b(gift\\s*cards?|steam\\s+cards?|itunes\\s+cards?|google\\s+play\\s+cards?|apple\\s+gift|razer\\s+gold)',
        '(scratch|send\\s+me|read\\s+me)[^.\\n]{0,20}(the\\s+)?(codes?|numbers?)\\s+(on|from)\\s+the\\s+(back|cards?)',
        '(kaufen|besorgen)[^.\\n]{0,30}(gutschein|geschenkkarte|paysafecard|google-?play-?karte|steam-?karte|apple-?karte)',
        '(compr|adquier)[a-záéíóú]*[^.\\n]{0,30}tarjetas?\\s+(regalo|de\\s+regalo|steam|google\\s+play|itunes|paysafecard)',
        '(achet|procur)[a-zéèê]*[^.\\n]{0,30}(cartes?\\s+(cadeau|pcs|transcash|neosurf|google\\s+play|steam)|coupons?\\s+(pcs|transcash|neosurf))',
        '(compr|adquir)[a-zãõáéíóú]*[^.\\n]{0,30}cart(ão|ões)\\s+(presente|de\\s+presente|google\\s+play|steam)',
        '(beli|belikan)[^.\\n]{0,30}(voucher|kartu\\s+hadiah|gift\\s*card|kode\\s+voucher)',
        '(상품권|기프트\\s*카드)[^.\\n]{0,20}(구매|사서|핀\\s*번호)',
        '(اشتر|شراء)[^.\\n]{0,30}بطاقات?\\s+(هدايا|هدية|ايتونز|آيتونز|جوجل\\s+بلاي|ستيم)'
    ] },
    { id: 'courier_cash', weight: 3, tier: 'absolute', re: [
        '(переда|отда)[а-яё]*\\s+(все\\s+)?(деньги|наличные|сбережения|средства)\\s+(курьеру|сотруднику|водителю|инкассатору)',
        'курьер[а-яё]*\\s+(заберёт|заберет|приедет\\s+за|забер[её]т)\\s+(деньги|наличн|сбережени)',
        'задекларир[а-яё]+\\s+(деньги|сбережени|средства|наличн)',
        '(переда|відда)[а-яіїєґ]*\\s+(гроші|готівку|кошти)\\s+кур\'?єру',
        '\\b(hand|give)\\s+(the\\s+|your\\s+)?(cash|money|savings|gold)\\s+(over\\s+)?to\\s+(a\\s+|the\\s+|our\\s+)?(courier|driver|agent|officer)',
        '\\bcourier\\s+will\\s+(collect|pick\\s+up|come\\s+for)\\s+(the\\s+|your\\s+)?(cash|money|card)',
        '(bargeld|geld|schmuck|gold)[^.\\n]{0,30}(abholer|kurier|boten|beamten)\\s+(übergeben|mitgeben|aushändigen)',
        '(kurier|abholer|bote)[^.\\n]{0,20}(holt|abholen)[^.\\n]{0,15}(bargeld|geld)',
        '(entregue|entregar|d[eé])\\s+(el\\s+|su\\s+)?(dinero|efectivo)\\s+al?\\s+(mensajero|repartidor|agente|funcionario)',
        '(remettez|donnez|remettre)\\s+(l[\'’]argent|les\\s+esp[eè]ces|le\\s+liquide|votre\\s+carte)\\s+(au|[àa]\\s+un|[àa]\\s+l[\'’])\\s*(coursier|livreur|agent)',
        '(entregue|d[eê])\\s+(o\\s+|seu\\s+)?(dinheiro|cart[aã]o)\\s+(ao|a\\s+um|para\\s+o)\\s+(motoboy|entregador|portador|funcion[aá]rio)',
        '(serahkan|berikan)\\s+(uang|uang\\s+tunai|kartu)\\s+(kepada|ke)\\s+(kurir|petugas)',
        '(현금|돈)[^.\\n]{0,20}(전달|건네)[^.\\n]{0,10}(직원|수거책|기사|금감원)',
        '(سلّم|سلم|أعط|اعط)\\s+(المال|النقود|الكاش|البطاقة)\\s+(إلى|الى|لل)\\s*(المندوب|مندوب|الساعي)'
    ] },

    /* ── решающие ──────────────────────────────────────────────────────── */
    { id: 'secrecy', weight: 3, tier: 'decisive', re: [
        'никому\\s+не\\s+(говорите|рассказывайте|говори|рассказывай)',
        'не\\s+(говорите|рассказывайте|сообщайте|говори|рассказывай)\\s+(никому|родственникам|близким|родным|детям|мужу|жене|в\\s+банк|сотрудникам\\s+банка)',
        'секретн[а-яё]+\\s+(операц|проверк|расследован|спецоперац)',
        'подписк[а-яё]+\\s+о\\s+неразглашени',
        '(разговор|операция|проверка)\\s+(является\\s+)?(конфиденциальн|секретн|тайн)',
        'нікому\\s+не\\s+(кажіть|розповідайте|кажи)',
        'не\\s+(кажіть|розповідайте|повідомляйте)\\s+(нікому|родичам|близьким|в\\s+банк)',
        'секретн[а-яіїєґ]+\\s+операці',
        '\\b(don\'?t|do\\s+not)\\s+tell\\s+(anyone|anybody|your\\s+(family|bank|husband|wife|kids|children|son|daughter))',
        '\\bkeep\\s+(this|it)\\s+(confidential|secret|between\\s+us)',
        '\\b(secret|confidential|covert|undercover)\\s+(operation|investigation)',
        '(sagen|erzählen)\\s+sie\\s+(niemandem|keinem)', '(geheime[n]?|verdeckte[n]?)\\s+(ermittlung|operation)',
        'no\\s+(se\\s+lo\\s+|le\\s+)?(digas|diga|cuentes|cuente|comente)\\s+(a\\s+nadie|nada\\s+a\\s+nadie|a\\s+(tu|su)\\s+familia)',
        '(operaci[oó]n|investigaci[oó]n)\\s+(secreta|confidencial)',
        'n[\'’]en\\s+parlez\\s+[àa]\\s+personne', 'ne\\s+(dites|dis)\\s+rien\\s+[àa]\\s+personne',
        '(op[ée]ration|enqu[êe]te)\\s+(secr[eè]te|confidentielle)',
        'n[aã]o\\s+(conte|fale|diga)\\s+(nada\\s+)?(para|a|pra)\\s+(ningu[ée]m|sua\\s+fam[ií]lia)',
        '(opera[çc][aã]o|investiga[çc][aã]o)\\s+(secreta|sigilosa)',
        'jangan\\s+(beritahu|bilang|kasih\\s+tahu|ceritakan)\\s+(ke\\s+|kepada\\s+)?(siapa\\s*pun|keluarga|siapapun)',
        '(operasi|penyelidikan)\\s+rahasia',
        '(아무에게도|아무한테도|가족에게도?|가족한테도?)\\s*(말하지|알리지)',
        '비밀\\s*(수사|작전|조사)',
        'لا\\s+(تخبر|تقل\\s+ل|تبلغ)\\s*(أحدا|احدا|أحداً|أي\\s+أحد|عائلتك)',
        '(عملية|تحقيق)\\s+سري'
    ] },
    { id: 'relative_trouble', weight: 3, tier: 'decisive', re: [
        '(?:^|[^а-яё])(мам[аоу]?|пап[аоу]?|бабушк[аи]|бабуль|дедушк[аи]|сын(ок)?|доч(ь|к[аи]|енька))[,!.]?\\s+это\\s+я[^\\n]{0,70}(деньги|денег|переведи|переведите|скинь|срочно|беда|беде|помоги|займи)',
        '(?:^|[^а-яё])(мам[аоу]?|пап[аоу]?|бабушк[аи]|бабуль|дедушк[аи]|сын(ок)?|доч(ь|к[аи]|енька))[,!.]?\\s+я\\s+(попал|попала|в\\s+беде|разбил|разбила|сбил|сбила|в\\s+больнице|в\\s+полиции)',
        '(?:^|[^а-яё])я\\s+попал[а]?\\s+в\\s+(беду|аварию|дтп|больницу|полицию|неприятност)',
        'сбил[а]?\\s+(человека|пешехода|женщину|мужчину|ребёнка|ребенка)',
        'меня\\s+(задержали|арестовали|забрали\\s+в\\s+полицию)',
        'нов[ыо][йе]\\s+номер[^\\n]{0,60}(деньги|денег|переведи|скинь|перекинь|срочно|займи|одолжи)',
        '(?:^|[^а-яё])(мам|пап|бабул|дедул|сестр|брат)[а-яё]*[^.\\n]{0,25}(это\\s+)?мой\\s+нов[ыо][йе]\\s+номер',
        '(разбил|потерял|утопил)[а]?\\s+телефон[^.\\n]{0,40}(номер|переведи|деньги|скинь)',
        '(?:^|[^а-яіїєґ])(мам[оа]|тат[оу]|бабус[юя]|сину|доню)[,!.]?\\s+(це\\s+я[^\\n]{0,70}(гроші|переведи|терміново|скинь|допоможи|позич)|я\\s+(потрапив|потрапила|в\\s+біді))',
        'потрапи(в|ла)\\s+в\\s+(біду|аварію|дтп)', 'збив\\s+(людину|пішохода)', 'мене\\s+затримали',
        'нов(ий|ого)\\s+номер[^\\n]{0,60}(гроші|переведи|терміново|скинь|позич)',
        '\\b(mum|mom|dad|grandma|grandpa|nan|nana)\\b,?\\s+it\'?s\\s+me[^\\n]{0,70}(money|send|transfer|urgent|help|pay|bill|trouble)',
        '\\bi\'?(m|ve)\\s+(been\\s+)?(in\\s+(an?\\s+)?(car\\s+)?(accident|trouble)|arrested)',
        '\\bnew\\s+number\\b[^\\n]{0,60}(money|send|transfer|urgent|pay|bill)',
        '\\b(lost|broke|dropped)\\s+my\\s+phone\\b[^.\\n]{0,40}(money|send|pay|transfer|bill)',
        '(mama|papa|oma|opa),?\\s+(ich\\s+bin\'?s[^\\n]{0,70}(geld|überweis|dringend|hilf|rechnung)|ich\\s+bin\\s+in\\s+schwierigkeiten)',
        '(mama|papa)[,!.]?\\s+(das\\s+ist\\s+)?meine\\s+neue\\s+nummer', 'ich\\s+hatte\\s+einen\\s+unfall',
        'neue\\s+nummer[^\\n]{0,70}(überweis|geld|dringend|rechnung)',
        '(mam[aá]|pap[aá]|abuel[ao]),?\\s+soy\\s+yo[^\\n]{0,70}(dinero|transfer|urgente|bizum|pagar|ayuda)', '(tuve|he\\s+tenido)\\s+un\\s+accidente',
        'nuevo\\s+n[uú]mero[^\\n]{0,70}(dinero|transfer|urgente|bizum|pagar)',
        '(maman|papa|mamie|papi),?\\s+c[\'’]est\\s+moi[^\\n]{0,70}(argent|virement|urgent|payer|facture|aide)', 'j[\'’]ai\\s+eu\\s+un\\s+accident',
        'nouveau\\s+num[ée]ro[^\\n]{0,70}(argent|virement|urgent|payer|facture)',
        '(m[aã]e|pai|v[óô]),?\\s+(sou\\s+eu|[ée]\\s+eu)[^\\n]{0,70}(pix|dinheiro|transfer|urgente|pagar|ajuda)', '(sofri|tive)\\s+um\\s+acidente',
        'n[uú]mero\\s+novo[^\\n]{0,70}(pix|dinheiro|transfer|urgente|pagar)',
        '(ma|mah|mama|pa|pak|papa|ibu|bu)[,!.]?\\s+(ini\\s+aku|ini\\s+saya)[^\\n]{0,70}(transfer|uang|pinjam|tolong|segera|darurat)',
        '(aku|saya)\\s+(kecelakaan|ditangkap|ditahan|kena\\s+masalah)',
        'nomor\\s+baru[^\\n]{0,70}(transfer|uang|pinjam|tolong)',
        '(엄마|아빠|할머니|할아버지)[,\\s]*(나야|나에요|저예요|저에요)[^\\n]{0,70}(돈|송금|보내|입금|급해|급하게)',
        '(사고|합의금)[^.\\n]{0,30}(돈|송금|보내|입금)',
        '(폰|휴대폰|핸드폰)\\s*(액정|고장|깨져|잃어)[^\\n]{0,70}(돈|송금|보내|입금|결제|상품권)',
        '(ماما|أمي|امي|بابا|أبي|ابي)[،,!]?\\s+(أنا|انا)[^\\n]{0,70}(حول|فلوس|مال|ادفع|ضروري|ساعد)',
        '(تعرضت|حصل\\s+لي)\\s+(ل)?حادث',
        'رقمي\\s+الجديد[^\\n]{0,70}(حول|فلوس|مال|ادفع)'
    ] },
    { id: 'card_details', weight: 3, tier: 'decisive', re: [
        '\\b(cvv2?|cvc2?|cvn)\\b',
        'три\\s+цифры\\s+(на\\s+обороте|с\\s+обратной|сзади)', 'срок\\s+действия\\s+(вашей\\s+|вашей\\s+банковской\\s+)?карты',
        'три\\s+цифри\\s+(на\\s+звороті|ззаду)',
        'three\\s+digits\\s+on\\s+the\\s+back', 'security\\s+code\\s+on\\s+the\\s+back',
        'kartenprüfnummer|prüfziffer\\s+(auf\\s+der\\s+rückseite|ihrer\\s+karte)',
        'tres\\s+d[ií]gitos\\s+(del\\s+reverso|de\\s+atr[aá]s)',
        'cryptogramme|trois\\s+chiffres\\s+au\\s+dos',
        'tr[eê]s\\s+d[ií]gitos\\s+(do\\s+verso|atr[aá]s)',
        'tiga\\s+(digit|angka)\\s+(di\\s+)?belakang',
        '카드\\s*뒷면\\s*(세|3)\\s*자리',
        'الأرقام\\s+الثلاثة\\s+(خلف|على\\s+ظهر)'
    ] },

    /* ── сильные ───────────────────────────────────────────────────────── */
    { id: 'bank_officer', weight: 2, re: [
        '(сотрудник|специалист|оператор|представител)[а-яё]*\\s+(банка|службы\\s+безопасности|цб|центробанка|центрального\\s+банка|росфинмониторинга|фсб|госуслуг|сотовой\\s+связи)',
        'служб[а-яё]+\\s+безопасности', 'следовател[а-яё]+',
        '(из|сотрудник[а-яё]*)\\s+(полиции|фсб|мвд|прокуратуры|росфинмониторинга|центробанка|центрального\\s+банка|следственного\\s+комитета)',
        '(співробітник|працівник)[а-яіїєґ]*\\s+(банку|служби\\s+безпеки|поліції|сбу|кіберполіції|нбу)',
        'служб[а-яіїєґ]+\\s+безпеки',
        '\\b(bank(\'s)?|fraud|security)\\s+(department|team|officer|investigator|protection)\\b',
        '\\b(from|with)\\s+(the\\s+)?(police|fbi|irs|hmrc|interpol|fraud\\s+squad)\\b',
        'sicherheitsabteilung|betrugsabteilung|kriminalpolizei|polizeibeamt|bankmitarbeiter|europol|bafin',
        '(departamento|equipo|servicio)\\s+de\\s+(seguridad|fraude|antifraude)', 'polic[ií]a\\s+(nacional|federal)|guardia\\s+civil',
        '(service|d[ée]partement|cellule)\\s+(de\\s+)?(s[ée]curit[ée]|fraude|anti-?fraude)', 'conseiller\\s+bancaire|gendarmerie|police\\s+nationale',
        '(central|departamento|setor)\\s+de\\s+(seguran[çc]a|fraude)', 'pol[ií]cia\\s+federal|delegado',
        '(petugas|pihak|bagian)\\s+(bank|keamanan|kepolisian|ojk)', '(dari|petugas)\\s+(polisi|kepolisian|ojk)',
        '(검찰|검사|수사관|금융감독원|경찰청|금감원)', '(은행|카드사)\\s*(보안팀|직원|상담원)',
        '(قسم|إدارة|ادارة)\\s+(الأمن|الاحتيال)', '(موظف|مندوب)\\s+(البنك|المصرف)', '(الشرطة|النيابة)'
    ] },
    { id: 'urgency', weight: 2, re: [
        'срочно', 'немедленно', 'в\\s+течение\\s+(\\d+\\s*)?(минут|час|часа|часов|суток)', 'сейчас\\s+же', 'последн[а-яё]+\\s+(предупрежден|шанс|уведомлен)',
        'терміново', 'негайно', 'протягом\\s+(\\d+\\s*)?(хвилин|години|годин|доби)',
        '\\burgent(ly)?\\b', '\\bimmediately\\b', '\\bwithin\\s+\\d+\\s+(minutes?|hours?)\\b', '\\bact\\s+now\\b', '\\bfinal\\s+(notice|warning)\\b',
        'dringend', 'sofort', 'umgehend', 'innerhalb\\s+von\\s+\\d+\\s+(minuten|stunden)', 'letzte\\s+mahnung',
        'urgente(mente)?', 'inmediatamente', 'en\\s+(las\\s+pr[oó]ximas\\s+)?\\d+\\s+(minutos|horas)', '[uú]ltimo\\s+aviso',
        '\\burgent\\b', 'imm[ée]diatement', 'sous\\s+\\d+\\s+(minutes|heures)', 'dernier\\s+(avis|rappel)',
        'imediatamente', 'em\\s+at[ée]\\s+\\d+\\s+(minutos|horas)',
        '\\bsegera\\b', 'sekarang\\s+juga', 'dalam\\s+\\d+\\s+(menit|jam)', 'peringatan\\s+terakhir',
        '긴급', '즉시', '지금\\s*바로', '\\d+\\s*(분|시간)\\s*(이내|안에)',
        'عاجل', 'فورا|فوراً', 'حالا', 'خلال\\s+\\d+\\s+(دقيقة|دقائق|ساعة|ساعات)'
    ] },
    { id: 'threat', weight: 2, re: [
        'заблокир[а-яё]+', 'уголовн[а-яё]+\\s+(дел|ответственност|преследован)', 'будет\\s+возбужден', 'аннулир[а-яё]+',
        '(номер|сим-?карт[а-яё]*)\\s+будет\\s+(отключ|заблокир)', 'арест[а-яё]*\\s+(сч[её]т|имуществ|средств)', 'штраф[а-яё]*\\s+(будет|в\\s+размере)',
        'заблоков[а-яіїєґ]+', 'кримінальн[а-яіїєґ]+\\s+(справ|відповідальн)',
        '\\b(account|card|access)\\b[^.\\n]{0,25}\\b(suspended|blocked|locked|deactivated|closed|frozen|restricted)\\b', '\\blegal\\s+action\\b', '\\barrest\\s+warrant\\b',
        '(konto|karte|zugang)[^.\\n]{0,30}(gesperrt|sperrung|deaktiviert|eingeschränkt)', 'strafanzeige|haftbefehl',
        '(cuenta|tarjeta)[^.\\n]{0,30}(bloquead|suspendid|desactivad|restringid)', 'orden\\s+de\\s+(arresto|detenci[oó]n)',
        '(compte|carte)[^.\\n]{0,30}(bloqu|suspendu|d[ée]sactiv|restreint)', 'mandat\\s+d[\'’]arr[êe]t|poursuites\\s+judiciaires',
        '(conta|cart[aã]o)[^.\\n]{0,30}(bloquead|suspens|desativad|restrit)', 'mandado\\s+de\\s+pris[aã]o',
        '(akun|rekening|kartu)[^.\\n]{0,30}(diblokir|dinonaktifkan|ditangguhkan|dibekukan)',
        '(정지|차단|동결)\\s*(됩니다|예정|처리|될)', '구속\\s*영장',
        '(سيتم\\s+)?(حظر|إيقاف|ايقاف|تجميد)\\s+(حسابك|بطاقتك)', 'أمر\\s+(قبض|اعتقال)'
    ] },
    { id: 'prize', weight: 2, re: [
        'вы\\s+(выиграли|стали\\s+победител|получили\\s+приз)', 'ваш\\s+(приз|выигрыш)', 'компенсаци[а-яё]+\\s+(за|от|в\\s+размере)',
        '(вам\\s+)?положен[аы]?\\s+(выплат|компенсаци)', 'розыгрыш[а-яё]*\\s+(айфон|iphone|денег|автомобил)',
        'ви\\s+виграли', 'ваш\\s+(приз|виграш)', 'компенсаці[а-яіїєґ]+\\s+(за|від|у\\s+розмірі)', 'вам\\s+належить\\s+виплата',
        '\\byou(\'ve|\\s+have)?\\s+won\\b', '\\bclaim\\s+your\\s+(prize|reward|refund|compensation)', '\\byou\\s+are\\s+(eligible|entitled)\\s+(for|to)\\s+(a\\s+)?(refund|compensation|payout)',
        'sie\\s+haben\\s+gewonnen', 'ihr\\s+gewinn', '(rückerstattung|entschädigung)\\s+(von|in\\s+höhe)',
        '(has|ha)\\s+ganado', 'su\\s+premio', 'reclam[ae]\\s+(tu|su)\\s+(premio|reembolso)',
        'vous\\s+avez\\s+gagn[ée]', 'votre\\s+(gain|lot|remboursement)\\s+(vous\\s+attend|est\\s+disponible)',
        'voc[eê]\\s+(ganhou|foi\\s+sorteado)', 'resgate\\s+(seu|o)\\s+(pr[eê]mio|reembolso)',
        '(anda|kamu)\\s+(memenangkan|mendapatkan\\s+hadiah|terpilih)', 'selamat[^.\\n]{0,20}(hadiah|pemenang)',
        '당첨(되셨|되었|자)', '(환급금|지원금|보상금)\\s*(신청|조회|지급)',
        '(لقد\\s+)?(فزت|ربحت)', 'جائزتك', 'استرداد\\s+(مبلغ|أموال)'
    ] },
    { id: 'investment', weight: 2, re: [
        'гарантированн[а-яё]+\\s+(доход|прибыл)', '\\d{2,4}\\s*%\\s*(в|за)\\s+(месяц|неделю|день|сутки)', '(инвестиц|вложени)[а-яё]*\\s+без\\s+риска',
        'удво(ить|им|ение|ите)\\s+(вложен|деньги|депозит|сумму)', 'пассивн[а-яё]+\\s+доход\\s+от',
        'гарантован[а-яіїєґ]+\\s+(дохід|прибут)', '\\d{2,4}\\s*%\\s*(на|за)\\s+(місяць|тиждень|день)',
        '\\bguaranteed\\s+(returns?|profits?|income)\\b', '\\d{2,4}\\s*%\\s*(a|per)\\s+(day|week|month)\\b', '\\bdouble\\s+your\\s+(money|crypto|investment)', '\\brisk[- ]free\\s+(investment|profit|returns?)',
        'garantierte[rn]?\\s+(rendite|gewinn)', '\\d{2,4}\\s*%\\s*(pro|im)\\s+(tag|woche|monat)', 'risikolose[rn]?\\s+(gewinn|anlage)',
        '(rentabilidad|ganancias?|beneficios?)\\s+garantizad', '\\d{2,4}\\s*%\\s*(al|por)\\s+(d[ií]a|semana|mes)', 'inversi[oó]n\\s+sin\\s+riesgo',
        '(rendement|profits?|gains?)\\s+garanti', '\\d{2,4}\\s*%\\s*par\\s+(jour|semaine|mois)', 'placement\\s+sans\\s+risque',
        '(lucro|retorno|rendimento)\\s+garantido', '\\d{2,4}\\s*%\\s*(ao|por)\\s+(dia|semana|m[eê]s)', 'investimento\\s+sem\\s+risco',
        '(keuntungan|profit|return)\\s+(pasti|dijamin)', '\\d{2,4}\\s*%\\s*per\\s+(hari|minggu|bulan)', 'investasi\\s+tanpa\\s+risiko',
        '(원금\\s*보장|수익\\s*보장|고수익\\s*보장)', '(하루|매일|월)\\s*\\d{1,3}\\s*%',
        '(أرباح|عائد)\\s+مضمون', '\\d{2,4}\\s*%\\s*(يوميا|شهريا|أسبوعيا)', 'استثمار\\s+بدون\\s+مخاطر'
    ] },
    { id: 'prepay', weight: 2, re: [
        'оплатит[ье]\\s+(комиссию|пошлину|таможенн|страховку|доставку|налог)', 'для\\s+(получения|вывода)[^.\\n]{0,30}(нужно|необходимо)\\s+(оплатить|внести|перевести)', 'предоплат[а-яё]+',
        'сплатіть\\s+(комісію|мито|доставку|податок)', 'для\\s+отримання[^.\\n]{0,30}(потрібно|необхідно)\\s+(сплатити|внести)',
        '\\bpay\\s+(a\\s+)?(small\\s+)?(fee|customs|tax|shipping|handling|processing)\\s+(to|before|in\\s+order|of)', '\\b(release|withdrawal|unlock)\\s+fee\\b',
        '(zahlen|überweisen)\\s+sie\\s+(eine\\s+)?(gebühr|zollgebühr|bearbeitungsgebühr)', 'zollgebühren\\s+(bezahlen|begleichen)',
        'pag(ue|ar)\\s+(una\\s+)?(tasa|comisi[oó]n|aduana|gastos\\s+de\\s+env[ií]o)\\s+(para|antes|de)',
        'pay(ez|er)\\s+(des\\s+|les\\s+)?(frais|droits\\s+de\\s+douane)\\s+(pour|avant|de)',
        'pag(ue|ar)\\s+(uma\\s+)?(taxa|tarifa)\\s+(para|de\\s+libera[çc][aã]o|antes)',
        '(bayar|transfer)\\s+(biaya|pajak|bea\\s+cukai|admin)\\s+(untuk|agar|terlebih|dulu)',
        '(수수료|세금|보증금)[^.\\n]{0,15}(먼저|선)\\s*(입금|결제)',
        '(ادفع|دفع)\\s+(رسوم|رسوما)\\s+(جمركية|التوصيل|الشحن|لـ)'
    ] },
    { id: 'job_tasks', weight: 2, re: [
        '(выполнен|выполня)[а-яё]*\\s+(простых\\s+)?задани', '(отзыв|лайк)[а-яё]*\\s+за\\s+(деньги|оплату|вознагражден)', 'от\\s+\\d[\\d\\s]*\\s*(₽|руб)[а-яё.]*\\s+в\\s+(день|сутки)',
        'виконанн[а-яіїєґ]+\\s+завдань', 'від\\s+\\d[\\d\\s]*\\s*(грн|₴)\\s+на\\s+день',
        '\\b(easy|simple)\\s+(online\\s+)?(money|tasks|job)\\b', '\\bpaid\\s+(reviews|likes|tasks)\\b', '\\bearn\\s+\\$?\\d{2,4}\\s+(a|per)\\s+day\\b',
        '(einfache|leichte)\\s+(aufgaben|online-?jobs?)', '\\d{2,4}\\s*(€|euro)\\s+(am|pro)\\s+tag\\s+verdienen',
        '(tareas|trabajo)\\s+(f[aá]cil|sencill)', 'gana\\s+\\d{2,4}\\s*(€|\\$|euros)\\s+al\\s+d[ií]a',
        '(t[aâ]ches|missions)\\s+simples', 'gagnez\\s+\\d{2,4}\\s*(€|euros)\\s+par\\s+jour',
        '(tarefas|trabalho)\\s+(simples|f[aá]cil)', 'ganhe\\s+r?\\$?\\s?\\d{2,4}\\s+por\\s+dia',
        '(tugas|kerja)\\s+(mudah|sederhana)', 'gaji\\s+(harian|per\\s+hari)', '(like|review|ulasan)\\s+dibayar',
        '(간단한|쉬운)\\s*(부업|알바)', '(하루|일당)\\s*\\d+\\s*만\\s*원',
        '(مهام|عمل)\\s+(بسيط|سهل)', 'اربح\\s+\\d{2,4}'
    ] },
    { id: 'crypto_wallet', weight: 2, re: [
        '(перевед|отправ|скин|перечисл)[а-яё]*\\s+(на\\s+)?(криптокошел|кошел[её]к|usdt|btc|биткоин|тетер|крипт)',
        '(usdt|btc|eth|trc-?20|erc-?20)\\s+(кошел|адрес)',
        '(переказ|надішл|скин)[а-яіїєґ]*\\s+(на\\s+)?(гаман|usdt|btc|біткоїн|крипт)',
        '\\b(send|transfer|deposit)\\s+(\\d+\\s+)?(usdt|btc|bitcoin|eth|crypto)\\s+to\\b', '\\b(trc-?20|erc-?20)\\b', '\\bwallet\\s+address\\b',
        '(überweisen|senden|schicken)[a-z]*\\s+(sie\\s+)?(\\d+\\s+)?(bitcoin|usdt|krypto)',
        '(env[ií]a|transfiere|env[ií]e)\\s+(\\d+\\s+)?(bitcoin|usdt|cripto)',
        '(envoyez|transf[ée]rez)\\s+(\\d+\\s+)?(bitcoin|usdt|crypto)',
        '(envie|transfira)\\s+(\\d+\\s+)?(bitcoin|usdt|cripto)',
        '(kirim|transfer)\\s+(\\d+\\s+)?(usdt|bitcoin|kripto)',
        '(비트코인|usdt|테더|코인)\\s*(으로|로)?\\s*(송금|입금|보내)',
        '(أرسل|حوّل|حول)\\s+(\\d+\\s+)?(بيتكوين|usdt|عملات\\s+رقمية)',
        '\\bbc1[ac-hj-np-z02-9]{25,60}\\b', '\\bT[1-9A-HJ-NP-Za-km-z]{33}\\b'
    ] },
    { id: 'operator_contract', weight: 2, re: [
        '(договор|срок\\s+действия)[^.\\n]{0,30}(номер|сим-?карт|оператор|связи)[^.\\n]{0,30}(истек|заканчива|закончил|прекращ)',
        '(продлит|продлени)[а-яё]*\\s+(договор|срок)[^.\\n]{0,30}(номер|связ|оператор|сим)',
        'номер\\s+(будет|может\\s+быть)\\s+(отключ|аннулир|заблокир|передан)', '(смен[аыу]|переход)\\s+(сотового\\s+)?оператор',
        '(договір|термін\\s+дії)[^.\\n]{0,30}(номер|сім|оператор)[^.\\n]{0,30}(закінч|спливає)', 'номер\\s+буде\\s+(відключ|заблоков)',
        '\\b(sim|number|contract)\\b[^.\\n]{0,20}\\b(will\\s+be\\s+)?(deactivated|disconnected|terminated)\\b'
    ] },
    { id: 'install_app', weight: 2, re: [
        '(установите|скачайте|загрузите|обновите)\\s+(приложени|программ|обновлени|версию)[а-яё]*[^.\\n]{0,40}(по\\s+ссылке|из\\s+сообщения|файл|apk|вложени)',
        '(приложени|версию|обновлени)[а-яё]*\\s+(банка\\s+|госуслуг\\s+)?по\\s+ссылке',
        '(встановіть|завантажте|оновіть)\\s+(додаток|застосунок|програму)[^.\\n]{0,40}(за\\s+посиланням|файл|apk)',
        '\\b(install|download)\\s+(the\\s+|this\\s+|our\\s+|a\\s+)?(new\\s+)?(app|application|update|apk)\\b[^.\\n]{0,40}\\b(link|below|attached|from\\s+this)',
        '(installieren|laden)\\s+sie\\s+(die\\s+|diese\\s+)?(app|anwendung)[^.\\n]{0,40}(link|herunter)',
        '(instal|descarg)(e|a|ue)\\s+(la\\s+)?(app|aplicaci[oó]n)[^.\\n]{0,40}(enlace|link)',
        '(install|t[ée]l[ée]charg)ez\\s+(l[\'’])?(app|application)[^.\\n]{0,40}lien',
        '(instal|baix)e\\s+o\\s+(app|aplicativo)[^.\\n]{0,40}link',
        '(install|unduh|download)\\s+(aplikasi|apk)[^.\\n]{0,40}(link|tautan)',
        '(앱|어플|apk)[^.\\n]{0,15}(설치|다운)[^.\\n]{0,15}(링크|주소)',
        '(ثبّت|ثبت|حمّل|حمل)\\s+(التطبيق|تطبيق)[^.\\n]{0,40}الرابط'
    ] },

    /* ── слабые ────────────────────────────────────────────────────────── */
    { id: 'delivery', weight: 1, re: [
        '(посылк|отправлени|заказ|груз)[а-яё]*\\s+(ожидает|задержан|не\\s+может\\s+быть\\s+доставлен|на\\s+таможне|не\\s+доставлен)', 'уточните\\s+(адрес|данные)\\s+(доставки|получателя)',
        'посилк[а-яіїєґ]+\\s+(очікує|затриман)', 'уточніть\\s+адресу\\s+доставки',
        '\\b(parcel|package|shipment|delivery)\\b[^.\\n]{0,15}\\b(waiting|on\\s+hold|held|pending|could\\s+not\\s+be\\s+delivered|unsuccessful)', '\\b(update|confirm)\\s+your\\s+(delivery\\s+|shipping\\s+)?address',
        '(paket|sendung)[^.\\n]{0,20}(wartet|zurückgehalten|nicht\\s+zugestellt)', 'adresse\\s+(bestätigen|aktualisieren)',
        '(paquete|env[ií]o)\\s+(est[aá]\\s+)?(retenido|pendiente|no\\s+pudo\\s+ser\\s+entregado)', '(actualice|confirme)\\s+(su\\s+)?direcci[oó]n',
        '(colis|livraison)\\s+(est\\s+)?(en\\s+attente|bloqu[ée]|retenu|n[\'’]a\\s+pas\\s+pu)', 'confirmez\\s+votre\\s+adresse',
        '(encomenda|pacote|entrega)\\s+(est[aá]\\s+)?(retid[ao]|pendente|n[aã]o\\s+p[ôo]de)', '(atualize|confirme)\\s+(seu\\s+)?endere[çc]o',
        'paket\\s+(anda\\s+)?(tertahan|tertunda|gagal\\s+dikirim)', '(perbarui|konfirmasi)\\s+alamat',
        '(택배|배송|소포)[^.\\n]{0,15}(보류|반송|주소\\s*불일치|미배달)',
        '(الشحنة|الطرد)\\s+(معلق|محتجز|لم\\s+يتم\\s+تسليم)', '(حدّث|حدث|أكد)\\s+عنوان'
    ] },
    { id: 'transfer_request', weight: 1, re: [
        '(переведите|перекиньте|скиньте|отправьте|переведи|скинь|перекинь)\\s+(мне\\s+)?(деньги|средства|\\d[\\d\\s]*\\s*(₽|р\\b|руб|тыс))',
        '(переведіть|перекиньте|скиньте|надішліть|переведи|скинь)\\s+(мені\\s+)?(гроші|кошти|\\d)',
        '\\b(send|transfer|wire)\\s+(me\\s+)?(the\\s+)?(money|funds|\\$\\s?\\d|\\d+\\s?(usd|eur|gbp|dollars|pounds))',
        '(überweise|überweisen\\s+sie|schick)\\s+(mir\\s+)?(bitte\\s+)?(\\d+\\s?(€|euro)|das\\s+geld)',
        '(transfiere|env[ií]a|m[aá]ndame|manda)(me)?\\s+(el\\s+)?(dinero|\\d+\\s?(€|\\$|euros|pesos))', 'hazme\\s+un\\s+bizum',
        '(virez|envoyez|envoie)[- ]?(moi\\s+)?(l[\'’]argent|\\d+\\s?(€|euros))',
        '(faz|fa[çc]a|manda)\\s+(um\\s+)?pix', '(transfira|envie)\\s+(o\\s+)?dinheiro',
        '(transfer|kirim)\\s+(uang|dana|dulu)', 'transferin',
        '(송금|입금|이체)\\s*(해\\s*줘|해주세요|부탁)',
        '(حوّل|حول|أرسل)\\s+(لي\\s+)?(المبلغ|فلوس|المال)'
    ] },
    { id: 'messenger_move', weight: 1, re: [
        '(пишите|напишите|переходите|добавляйтесь|свяжитесь)\\s+(мне\\s+|нам\\s+)?(в|через)\\s+(телеграм|telegram|телегу|тг|ватсап|вотсап|whatsapp|вайбер|viber)',
        '(пишіть|напишіть|переходьте)\\s+(мені\\s+|нам\\s+)?(в|у|через)\\s+(телеграм|telegram|вайбер|viber|whatsapp)',
        '\\b(text|message|contact|add|dm)\\s+(me|us)\\s+on\\s+(telegram|whatsapp|signal)\\b',
        '(schreiben\\s+sie|kontaktieren\\s+sie)\\s+(mir|uns)\\s+(auf|über|per)\\s+(telegram|whatsapp)',
        '(escr[ií]beme|escr[ií]benos|cont[aá]ctanos)\\s+(por|en)\\s+(telegram|whatsapp)',
        '([ée]crivez|contactez)[- ]?(moi|nous)\\s+sur\\s+(telegram|whatsapp)',
        '(me\\s+chame|chama|fale\\s+comigo)\\s+no\\s+(telegram|whatsapp|zap)',
        '(hubungi|chat)\\s+(kami|saya)\\s+(di|via|lewat)\\s+(telegram|whatsapp|wa)',
        '(텔레그램|카톡|카카오톡)\\s*(으로|로)?\\s*(연락|문의)',
        '(تواصل|راسلني|راسلنا)\\s+(معي|معنا)?\\s*(على|عبر)\\s+(تيليجرام|واتساب|واتس)'
    ] },
    { id: 'call_number', weight: 1, re: [
        '(позвоните|перезвоните|свяжитесь|звоните)[^.\\n]{0,30}(\\+?\\d[\\d\\s()-]{9,})',
        '(зателефонуйте|передзвоніть|телефонуйте)[^.\\n]{0,30}(\\+?\\d[\\d\\s()-]{9,})',
        '\\b(call|contact|ring)\\b[^.\\n]{0,25}(\\+?\\d[\\d\\s()-]{9,})',
        '(rufen\\s+sie|kontaktieren\\s+sie)[^.\\n]{0,25}(\\+?\\d[\\d\\s()/-]{9,})',
        '(llame|ll[aá]menos|contacte|comun[ií]quese)[^.\\n]{0,25}(\\+?\\d[\\d\\s()-]{9,})',
        '(appelez|rappelez|contactez)[^.\\n]{0,25}(\\+?\\d[\\d\\s().-]{9,})',
        '(ligue|entre\\s+em\\s+contato)[^.\\n]{0,25}(\\+?\\d[\\d\\s()-]{9,})',
        '(hubungi|telepon)[^.\\n]{0,25}(\\+?\\d[\\d\\s()-]{9,})',
        '(\\+?\\d[\\d\\s()-]{9,})[^.\\n]{0,15}(연락|전화)',
        '(اتصل|تواصل)[^.\\n]{0,25}(\\+?\\d[\\d\\s()-]{9,})'
    ] }
];
TEXT_SIGNALS.forEach(function (sig) { sig.re = sig.re.map(R); });

/* Фразы настоящих уведомлений. Совпадение признака, которое целиком лежит
   внутри такой фразы, не считается: «не сообщайте никому этот код» — это не
   требование секретности, а банк. Мошенники копируют и это, поэтому сам
   факт защитной фразы НИЧЕГО не разрешает — он только не обвиняет. */
var PROTECTIVE = [
    'не\\s+(сообщайте|говорите|называйте|передавайте|показывайте)\\s+(никому\\s+)?(этот\\s+|данный\\s+|его\\s+)?(код|пароль)(\\s+никому)?',
    'никому\\s+не\\s+(сообщайте|говорите|называйте|передавайте|показывайте)\\s+(этот\\s+|данный\\s+)?(код|пароль)',
    '(сотрудники?|банк)\\s+(банка\\s+)?никогда\\s+не\\s+(спрашива|запрашива|просит|попрос)[а-яё]*',
    'никому\\s+не\\s+(сообщайте|говорите|называйте|передавайте|показывайте)\\s+(его|е[её]|этот\\s+код|код|пароль)(,?\\s+(даже|в\\s+том\\s+числе)\\s+сотрудник[а-яё]*\\s+банка)?',
    'не\\s+(сообщайте|называйте|передавайте)\\s+(его|код|пароль)\\s+(никому,?\\s+)?(даже|в\\s+том\\s+числе)\\s+сотрудник[а-яё]*\\s+банка',
    'не\\s+(повідомляйте|кажіть|називайте|передавайте)\\s+(нікому\\s+)?(цей\\s+)?(код|пароль)(\\s+нікому)?',
    'нікому\\s+не\\s+(повідомляйте|кажіть|називайте)\\s+(цей\\s+)?(код|пароль)',
    'не\\s+(повідомляйте|кажіть|називайте|передавайте)\\s+(його|цей\\s+код|код|пароль)[^.\\n]{0,20}(навіть|у\\s+тому\\s+числі)\\s+(працівник|співробітник)[а-яіїєґ]*\\s+банку',
    '\\b(never|do\\s+not|don\'?t)\\s+(share|tell|give)\\s+(this|the|your)\\s+(code|otp|password|pin)(\\s+(with|to)\\s+anyone)?',
    '\\bwe\\s+(will\\s+)?never\\s+ask\\s+(you\\s+)?for',
    '(geben\\s+sie|teilen\\s+sie|nennen\\s+sie)\\s+(diesen\\s+|den\\s+)?code\\s+(niemals|nicht|niemandem)(\\s+weiter)?',
    'no\\s+(compartas|comparta|facilites|facilite)\\s+(este|el|tu|su)\\s+c[oó]digo', 'nunca\\s+(compartas|comparta)',
    'ne\\s+(le\\s+)?(communiquez|partagez|donnez)\\s+(jamais|pas|[àa]\\s+personne)', 'ne\\s+communiquez\\s+(jamais\\s+)?ce\\s+code',
    'n[aã]o\\s+(compartilhe|informe|passe)\\s+(este|o|seu)\\s+c[oó]digo', 'nunca\\s+(compartilhe|informe)',
    'jangan\\s+(berikan|bagikan|beritahukan|sebutkan)\\s+(kode|otp)(\\s+ini)?(\\s+(kepada|ke)\\s+siapa\\s*pun)?',
    '(타인에게|누구에게도|절대)\\s*(알려주지|노출하지|공유하지)\\s*마세요',
    'لا\\s+(تشارك|تعطي|تخبر)\\s+(هذا\\s+)?(الرمز|الكود)'
].map(R);

/* Отрицание прямо перед просьбой: «не называйте код» — не просьба. */
var NEG_BEFORE = /(?:^|[\s,.;:!?«"(])(не|ні|not|never|don'?t|do\s+not|nicht|niemals|nie|no|nunca|jam[aá]s|ne|jamais|n[aã]o|jangan|لا|ولا)\s+$/iu;
/* Корейское отрицание стоит ПОСЛЕ глагола: «알려주지 마세요». */
var NEG_AFTER = /^[가-힣]{0,3}\s*(지\s*마|마세요|말아|않)/u;

/* Признаки, которые гаснут, если лишь ЗАДЕВАЮТ защитную фразу: у просьбы
   назвать код и у «секретности» законная форма — ровно эта фраза. */
var PROTECT_BY_OVERLAP = { sms_code: 1, secrecy: 1, bank_officer: 1 };
var NEGATABLE = { sms_code: 1, remote_access: 1, gift_cards: 1, transfer_request: 1, safe_account: 1 };
/* Два РАЗНЫХ шаблона одного признака в одном тексте — это уже не оборот
   речи: «простые задания» И «от 5000 руб в день». */
var BOOST_ON_TWO = { job_tasks: 1, investment: 1, prize: 1, secrecy: 1, relative_trouble: 1 };

function analyzeText(text) {
    var s = String(text || '');
    var prot = [];
    PROTECTIVE.forEach(function (re) {
        var g = new RegExp(re.source, 'giu'), m;
        while ((m = g.exec(s))) { prot.push([m.index, m.index + m[0].length]); if (!m[0].length) g.lastIndex++; }
    });
    function inside(a, b) { return prot.some(function (p) { return a >= p[0] - 2 && b <= p[1] + 2; }); }
    function overlaps(a, b) { return prot.some(function (p) { return a < p[1] && b > p[0]; }); }

    var flags = [];
    TEXT_SIGNALS.forEach(function (sig) {
        var found = null, distinct = 0;
        for (var i = 0; i < sig.re.length; i++) {
            var g = new RegExp(sig.re[i].source, 'giu'), m, hit = null;
            while ((m = g.exec(s))) {
                if (!m[0].length) { g.lastIndex++; continue; }
                var a = m.index, b = a + m[0].length;
                if (PROTECT_BY_OVERLAP[sig.id] ? overlaps(a, b) : inside(a, b)) continue;
                if (NEGATABLE[sig.id]) {
                    var lead = m[0].match(/^\s*/)[0].length;
                    if (NEG_BEFORE.test(s.slice(Math.max(0, a + lead - 14), a + lead))) continue;
                    if (NEG_AFTER.test(s.slice(b, b + 8))) continue;
                }
                hit = m[0].trim();
                break;
            }
            if (hit) {
                distinct++;
                if (!found) found = hit;
                if (!BOOST_ON_TWO[sig.id] || distinct >= 2) break;
            }
        }
        if (found) {
            var boosted = BOOST_ON_TWO[sig.id] && distinct >= 2;
            var tier = boosted ? (sig.tier === 'decisive' ? 'absolute' : (sig.tier || 'decisive')) : (sig.tier || null);
            flags.push({ id: sig.id, weight: tier ? 3 : sig.weight, tier: tier, decisive: !!tier, boosted: boosted || undefined, data: { match: found.slice(0, 70) } });
        }
    });
    return { flags: flags, protective: prot.length > 0 };
}

/* ═══════════════════════════════════════════════════════════════════════
   ВЕРДИКТ
   ═══════════════════════════════════════════════════════════════════════ */

/**
 * verdict: 'scam'       — абсолютный признак, или решающий плюс любой другой;
 *          'likely'     — один решающий без поддержки, или два сильных;
 *          'suspicious' — один сильный или несколько слабых;
 *          'unclear'    — ничего не найдено (это НЕ «безопасно»).
 *
 * ⚠️ Худший вывод здесь — «всё чисто». Чистого «безопасно» НЕТ ни при каких
 * условиях.
 */
function check(input) {
    var text = String(input || '');
    var urls = findUrlsDetailed(text);
    var t = analyzeText(text);
    var flags = t.flags.slice();
    var urlReports = urls.map(function (x) {
        var r = analyzeUrl(x.url, { bare: x.bare });
        r.shown = x.shown;
        r.flags.forEach(function (f) { flags.push(Object.assign({ url: x.url }, f)); });
        return r;
    });

    /* Один и тот же признак от двух ссылок — одна строка в выводе. */
    var seen = {};
    flags = flags.filter(function (f) {
        var k = f.id + '|' + (f.data && (f.data.brand || f.data.host || f.data.label) || '');
        if (seen[k]) return false;
        seen[k] = 1;
        return true;
    });

    var absolute = flags.filter(function (f) { return f.tier === 'absolute'; });
    var decisive = flags.filter(function (f) { return f.tier === 'decisive'; });
    var strong = flags.filter(function (f) { return !f.tier && f.weight >= 2; });
    var weak = flags.filter(function (f) { return !f.tier && f.weight === 1; });
    var others = flags.length - decisive.length;

    var verdict;
    if (absolute.length) verdict = 'scam';
    else if (decisive.length >= 2 || (decisive.length === 1 && (strong.length + weak.length) >= 1)) verdict = 'scam';
    else if (decisive.length === 1 || strong.length >= 2 || (strong.length === 1 && weak.length >= 2)) verdict = 'likely';
    else if (strong.length === 1 || weak.length >= 2) verdict = 'suspicious';
    else verdict = 'unclear';

    var rank = { absolute: 0, decisive: 1 };
    return {
        verdict: verdict,
        flags: flags.sort(function (a, b) {
            var ra = a.tier ? rank[a.tier] : 5 - a.weight, rb = b.tier ? rank[b.tier] : 5 - b.weight;
            return ra - rb;
        }),
        decisive: absolute.concat(decisive),
        urls: urlReports,
        protective: t.protective,
        counts: { absolute: absolute.length, decisive: decisive.length, strong: strong.length, weak: weak.length, others: others }
    };
}

/* ═══════════════════════════════════════════════════════════════════════
   СЕМЕЙНОЕ КОДОВОЕ СЛОВО
   ═══════════════════════════════════════════════════════════════════════
   Два несвязанных слова ОДНОГО языка, согласованные по роду, в естественном
   для языка порядке. Первая версия смешивала языки и выдавала «левый anchor»:
   такое слово трудно произнести в разговоре, где человек уже напуган.
*/
var WORD_PARTS = {
    ru: { order: 'an', adj: ['синий', 'старый', 'громкий', 'рыжий', 'тихий', 'острый', 'мокрый', 'левый', 'круглый', 'тёплый', 'быстрый', 'колючий', 'кривой', 'полосатый'],
          noun: ['якорь', 'фонарь', 'кактус', 'чайник', 'вагон', 'компас', 'ключ', 'зонт', 'валенок', 'бублик', 'штурвал', 'сверчок', 'барабан', 'пингвин'] },
    uk: { order: 'an', adj: ['синій', 'старий', 'гучний', 'рудий', 'тихий', 'гострий', 'мокрий', 'лівий', 'круглий', 'теплий', 'швидкий', 'колючий', 'кривий', 'смугастий'],
          noun: ['якір', 'ліхтар', 'кактус', 'чайник', 'вагон', 'компас', 'ключ', 'човен', 'черевик', 'бублик', 'штурвал', 'цвіркун', 'барабан', 'пінгвін'] },
    en: { order: 'an', adj: ['blue', 'old', 'loud', 'ginger', 'quiet', 'sharp', 'wet', 'left', 'round', 'warm', 'quick', 'spiky', 'crooked', 'striped'],
          noun: ['anchor', 'lantern', 'cactus', 'kettle', 'wagon', 'compass', 'key', 'umbrella', 'boot', 'bagel', 'rudder', 'cricket', 'drum', 'penguin'] },
    de: { order: 'an', adj: ['blauer', 'alter', 'lauter', 'roter', 'stiller', 'spitzer', 'nasser', 'runder', 'warmer', 'schneller', 'goldener', 'schiefer', 'gestreifter', 'kleiner'],
          noun: ['Anker', 'Kaktus', 'Kessel', 'Wagen', 'Kompass', 'Schlüssel', 'Schirm', 'Stiefel', 'Pinguin', 'Bagel', 'Hammer', 'Igel', 'Leuchtturm', 'Trommler'] },
    es: { order: 'na', adj: ['azul', 'viejo', 'ruidoso', 'pelirrojo', 'tranquilo', 'afilado', 'mojado', 'redondo', 'rápido', 'dorado', 'torcido', 'rayado', 'pequeño', 'tibio'],
          noun: ['farol', 'cactus', 'tambor', 'vagón', 'compás', 'paraguas', 'pingüino', 'bizcocho', 'timón', 'grillo', 'cohete', 'zapato', 'erizo', 'faro'] },
    fr: { order: 'na', adj: ['bleu', 'rouge', 'bruyant', 'tranquille', 'pointu', 'mouillé', 'rond', 'rapide', 'doré', 'tordu', 'rayé', 'gelé', 'sucré', 'têtu'],
          noun: ['phare', 'cactus', 'tambour', 'wagon', 'compas', 'parapluie', 'pingouin', 'biscuit', 'gouvernail', 'grillon', 'chausson', 'bateau', 'hérisson', 'marteau'] },
    pt: { order: 'na', adj: ['azul', 'velho', 'barulhento', 'ruivo', 'quieto', 'afiado', 'molhado', 'redondo', 'rápido', 'dourado', 'torto', 'listrado', 'pequeno', 'morno'],
          noun: ['farol', 'cacto', 'tambor', 'vagão', 'compasso', 'guarda-chuva', 'pinguim', 'biscoito', 'leme', 'grilo', 'foguete', 'sapato', 'ouriço', 'martelo'] },
    id: { order: 'na', adj: ['biru', 'tua', 'berisik', 'merah', 'tenang', 'tajam', 'basah', 'bulat', 'hangat', 'cepat', 'miring', 'belang', 'mungil', 'manis'],
          noun: ['jangkar', 'lentera', 'kaktus', 'ketel', 'gerbong', 'kompas', 'kunci', 'payung', 'sepatu', 'donat', 'kemudi', 'jangkrik', 'drum', 'penguin'] },
    ko: { order: 'an', adj: ['파란', '낡은', '시끄러운', '빨간', '조용한', '뾰족한', '젖은', '둥근', '따뜻한', '빠른', '노란', '작은', '줄무늬', '달콤한'],
          noun: ['닻', '등불', '선인장', '주전자', '기차', '나침반', '열쇠', '우산', '장화', '도넛', '방패', '귀뚜라미', '북', '펭귄'] },
    ar: { order: 'na', adj: ['أزرق', 'قديم', 'صاخب', 'أحمر', 'هادئ', 'حاد', 'مبلل', 'مستدير', 'دافئ', 'سريع', 'ذهبي', 'صغير', 'مخطط', 'حلو'],
          noun: ['فانوس', 'صبار', 'إبريق', 'قطار', 'مفتاح', 'حذاء', 'جرس', 'طبل', 'صندوق', 'قمر', 'بطريق', 'قارب', 'شمعدان', 'كعك'] }
};

function codeword(lang, rng) {
    var key = WORD_PARTS[lang] ? lang : ((lang || '').slice(0, 2));
    var bank = WORD_PARTS[key] || WORD_PARTS.en;
    var pick = function (arr) {
        var n;
        if (rng) n = rng(arr.length);
        else if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
            /* Отбрасывание хвоста — без смещения к первым словам списка. */
            var lim = Math.floor(0x100000000 / arr.length) * arr.length, b = new Uint32Array(1);
            do { crypto.getRandomValues(b); } while (b[0] >= lim);
            n = b[0] % arr.length;
        } else {
            throw new Error('secure randomness unavailable');
        }
        return arr[n];
    };
    var a = pick(bank.adj), n = pick(bank.noun);
    return bank.order === 'na' ? n + ' ' + a : a + ' ' + n;
}

return {
    SCRIPT_RANGES: SCRIPT_RANGES, CONFUSABLE: CONFUSABLE, BRANDS: BRANDS, PHISH_AFFIX: PHISH_AFFIX,
    SHORTENERS: SHORTENERS, RISKY_TLDS: RISKY_TLDS, TEXT_SIGNALS: TEXT_SIGNALS, WORD_PARTS: WORD_PARTS,
    scriptsIn: scriptsIn, skeleton: skeleton, punyDecode: punyDecode, decodeLabel: decodeLabel,
    findUrls: findUrls, findUrlsDetailed: findUrlsDetailed, parseUrl: parseUrl, analyzeUrl: analyzeUrl, brandHit: brandHit,
    analyzeText: function (text) { return analyzeText(text).flags; },
    analyzeTextFull: analyzeText, check: check, codeword: codeword
};
});
